<template>
  <div class="voice-synthesis">
    <!-- 左侧：合成记录区域 -->
    <div class="synthesis-record">
      <h3 class="record-title">合成记录</h3>
      <div class="search-area">
        <el-input v-model="searchValue" placeholder="名称" class="search-input" clearable>
          <template #prefix>
            <i class="el-icon-search" style="color: #ccc"></i>
          </template>
        </el-input>
        <el-button type="primary" class="search-button" @click="fetchSynthesisRecordz">查询</el-button>
      </div>
      <div v-if="synthesisRecords.length > 0" class="record-list">
        <div v-for="record in synthesisRecords" :key="record.id" class="record-item"
          :class="getStatusClass(record.status)">
          <!-- 删除按钮 -->
          <el-button class="delete-button" type="text" @click.stop="handleDeleteRecord(record)">
            <img src="https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/images/20250122/20250122233241207982156.png"
              alt="删除" style="width: 16px; height: 16px;" />
          </el-button>
          <!-- 新增下载按钮 -->
          <el-button class="download-button" type="text" @click.stop="handleDownload(record)">
            <img src="https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/images/20250405/202504051643118b1f97521.png"
              alt="下载" style="width: 16px; height: 16px;" />
          </el-button>
          <div class="record-info">
            <p class="record-title">{{ record.title }}</p>
            <p class="record-time">创建时间：{{ record.create_time }}</p>
            <p class="record-time">配音人员：{{ record.author }}</p>
            <p class="record-status">{{ record.status }}</p>
          </div>

          <div class="record-actions">
            <!-- 试听音频按钮 -->
            <el-button type="text" :disabled="record.status !== '已完成'" @click.stop="toggleAudioPlay(record)"
              class="action-button">
              {{ record.isPlaying ? '停止音频' : '试听音频' }}
            </el-button>

            <!-- 命名音频按钮 -->
            <el-button type="text" :disabled="record.status !== '已完成'" @click.stop="openRenameDialog(record)"
              class="action-button">
              命名音频
            </el-button>
          </div>
        </div>
      </div>
      <div v-else class="no-record">
        <el-empty description="暂无合成记录" />
      </div>
    </div>
    <!-- 自定义弹窗 -->
    <el-dialog v-model="videoParseDialogVisible" title="文案解析" width="30%">
      <el-input v-model="videoUrl" placeholder="请输入视频链接" @input="handleInput" />
      <template #footer>
        <el-button @click="videoParseDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleVideoParse" :loading="isLoadings"
          style="background: #ff5c00;border: none;">确认</el-button>
      </template>
    </el-dialog>
    <!-- 命名音频弹窗 -->
    <el-dialog v-model="renameDialogVisible" title="命名音频" width="30%">
      <el-input v-model="newTitle" placeholder="请输入新的音频名称" />
      <template #footer>
        <el-button @click="renameDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleRename" style="background: #ff5c00;border: none;">确定</el-button>
      </template>
    </el-dialog>

    <!-- 右侧：主要编辑/操作区域 + 声音库 -->
    <div class="right-content">
      <!-- 主要编辑/操作区域 -->
      <div class="left-panel">
        <!-- 名称行 -->
        <div class="name-row">
          <span class="label">名称</span>
          <el-input v-model="voiceName" placeholder="请输入声音的名称，方便查找识别" class="voice-name-input" />
        </div>

        <div class="textarea-container">
          <textarea v-model="voiceText" class="el-textarea__inner" tabindex="0" autocomplete="off"
            placeholder="欢迎使用语音合成内容" rows="16" style="resize: none; height: 382px;"></textarea>
          <div class="word-count">
            {{ currentWords }}/{{ maxWords }}
          </div>
        </div>

        <!-- AI操作按钮行 (AI改写/AI制作等) -->
        <div class="ai-operation-row">
          <!-- 下拉框与转换按钮 -->
          <div class="dropdown-controls">
            <el-tooltip placement="top" popper-class="custom-tooltip">
              <template #content>
                支持国内外各大短视频平台：<br>
                抖音，皮皮虾，小红书，微博，快手，QQ小世界，<br>
                皮皮搞笑，最右，微视，美拍，西瓜，哔哩哔哩，<br>
                虎牙，梨视频，新片场，Twitch，Snapchat，<br>
                FackBook，Vk，Instagram。<br>
              </template>
              <el-button type="primary" @click="handleConversion" class="conversion-button" :disabled="isThinking">
                文案解析
              </el-button>
            </el-tooltip>
          </div>

          <el-input placeholder="请告诉我需要写些什么" v-model="aiInput" class="ai-input" :disabled="isThinking" />
          <el-button type="primary" :loading="isLoadingz" @click="handleAICreate" class="ai-create-button"
            :disabled="isThinking">
            AI创作
          </el-button>
        </div>
      </div>

      <!-- 声音库/我的语音 -->
      <div class="right-panel">
        <!-- Tabs -->
        <el-tabs v-model="activeTab" class="voice-tabs">
          <el-tab-pane label="声音库" name="ai-male">
            <div class="voice-options">
              <div class="voice-card" :class="{ 'is-selected': voice.isSelected }"
                v-for="(voice, index) in voicelibrary" :key="voice.title"
                @click="handleVoiceCardClick('voicelibrary', index)">
                <div class="play-icon" @click.stop="togglePlay('voicelibrary', index)">
                  <svg v-if="!voice.isPlaying" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    viewBox="0 0 56 56">
                    <circle cx="28" cy="28" r="28" fill="#FF5C00" />
                    <path
                      d="M21.5 20.5c0-1.8 2.1-3 3.6-2l12.5 8.1c1.4.9 1.4 3 0 3.9l-12.5 8.1c-1.5 1-3.6-.1-3.6-2V20.5z"
                      fill="#fff" />
                  </svg>
                  <!-- 播放中的样式 -->
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 56 56">
                    <circle cx="28" cy="28" r="28" fill="#FF5C00" />
                    <rect x="20" y="18" width="4" height="20" fill="#fff" />
                    <rect x="32" y="18" width="4" height="20" fill="#fff" />
                  </svg>
                </div>
                <div class="voice-info">
                  <p class="voice-title">{{ voice.title }}</p>
                  <p class="voice-tag">{{ voice.model }}</p>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="我的语音" name="my-voice">
            <div class="voice-options">
              <div class="voice-card" :class="{ 'is-selected': voice.isSelected }" v-for="(voice, index) in myvoice"
                :key="voice.title" @click="handleVoiceCardClick('my-voice', index)">
                <div class="play-icon" @click.stop="togglePlay('my-voice', index)">
                  <svg v-if="!voice.isPlaying" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    viewBox="0 0 56 56">
                    <circle cx="28" cy="28" r="28" fill="#FF5C00" />
                    <path
                      d="M21.5 20.5c0-1.8 2.1-3 3.6-2l12.5 8.1c1.4.9 1.4 3 0 3.9l-12.5 8.1c-1.5 1-3.6-.1-3.6-2V20.5z"
                      fill="#fff" />
                  </svg>
                  <!-- 播放中的样式 -->
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 56 56">
                    <circle cx="28" cy="28" r="28" fill="#FF5C00" />
                    <rect x="20" y="18" width="4" height="20" fill="#fff" />
                    <rect x="32" y="18" width="4" height="20" fill="#fff" />
                  </svg>
                </div>
                <div class="voice-info">
                  <p class="voice-title">{{ voice.title }}</p>
                  <p class="voice-tag">{{ voice.model }}</p>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!-- 底部：滑块与合成按钮 -->
        <div class="sliders-and-button">
          <el-button type="primary" :loading="isLoadingd" class="synthesize-button" @click="handleSynthesize">
            合成声音
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { auth } from "@/utils/auth.js"; // 引入封装的 auth.js
import config from '@/config.js'; // 引入配置文件
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  name: "VoiceSynthesis",
  data() {
    return {
      // 左侧搜索关键字
      searchValue: "",
      // 右侧：名称/文本输入
      voiceName: "",
      voiceText: "",
      // AI 输入
      aiInput: "",
      // 当前激活的tab
      activeTab: "ai-male",
      // 声音库和我的语音数据
      voicelibrary: [], // 声音库数据
      myvoice: [], // 我的语音数据
      audioElement: null, // 用于控制音频播放的 DOM 元素
      currentPlayingIndex: null, // 当前正在播放的音频索引
      currentPlayingType: null, // 当前正在播放的音频类型（voicelibrary 或 myvoice）
      // 滑块值（示例中未使用，可按需添加）
      volume: 50,
      pitch: 1,
      speed: 1,
      // 加载状态
      isThinking: false, // 是否正在思考（加载中）
      openaiConfig: {}, // 存储 OpenAI 配置
      synthesisRecords: [], // 合成记录数据
      renameDialogVisible: false, // 命名音频弹窗是否可见
      newTitle: "", // 新的音频名称
      currentRecord: null, // 当前操作的记录
      maxWords: 600, // 最大字数限制
      currentWords: 0, // 当前字数，默认为 0
      videoParseDialogVisible: false, // 控制弹窗显示
      videoUrl: "", // 视频链接输入框的值
      isLoadings: false,  // 控制按钮 loading 状态
      isLoadingz: false,  // 控制按钮 loading 状态
      isLoadingd: false,  // 控制按钮 loading 状态
    };
  },
  created() {
    this.fetchSynthesisRecords(); // 获取合成记录
    this.fetchVoiceData(); // 获取声音数据
    this.fetchOpenAIConfig(); // 获取 OpenAI 配置
    this.fetchVideoClarityValues(); // 调用接口获取字数限制

  },
  watch: {
    voiceText(newValue) {
      this.currentWords = newValue.length; // 更新当前字数
      if (newValue.length > this.maxWords) {
        this.voiceText = newValue.slice(0, this.maxWords); // 限制字数
      }
    },
  },
  methods: {

    handleDownload(record) {
      if (!record.voice_clone_url) {
        this.$message.error("音频链接无效");
        return;
      }

      // 强制下载方案
      const xhr = new XMLHttpRequest();
      xhr.open('GET', record.voice_clone_url, true);
      xhr.responseType = 'blob';

      xhr.onload = () => {
        if (xhr.status === 200) {
          const blob = new Blob([xhr.response]);
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${record.title || 'audio'}.mp3`;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      };

      xhr.send();
    },
    // 获取合成记录
    async fetchSynthesisRecords() {
      const user = auth.getStoredUser(); // 从本地存储获取用户信息
      if (!user || !user.id) {
        this.$message.error("用户未登录或用户ID无效");
        return;
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/voice_clone_api.php`, {
          action: "get",
          user_id: user.id,
        });

        if (response.data.success) {
          // 对数据进行排序，确保最新的数据在最前面
          this.synthesisRecords = response.data.data
            .map(record => ({
              ...record,
              isPlaying: false, // 初始化播放状态
            }))
            .sort((a, b) => new Date(b.create_time) - new Date(a.create_time)); // 按创建时间降序排序
        } else {
          this.$message.error("获取合成记录失败");
        }
      } catch (error) {
        console.error("获取合成记录失败:", error);
        this.$message.error("获取合成记录失败，请检查网络");
      }
    },
    // 点击“文案解析”按钮时显示弹窗
    handleConversion() {
      this.videoParseDialogVisible = true;
    },
    handleInput(value) {
      // 简单的 URL 格式检查
      if (!value.startsWith('http://') && !value.startsWith('https://')) {
        this.$message.warning('请输入有效的视频链接');
        this.videoUrl = ''; // 清空输入
      }
    },
    // 处理视频解析
    async handleVideoParse() {
      const user = auth.getStoredUser(); // 从本地存储获取用户信息
      if (!user || !user.id) {
        this.$message.error("用户未登录或用户ID无效");
        return;
      }

      if (!this.videoUrl.trim()) {
        this.$message.warning("请输入视频链接");
        return;
      }

      this.isLoadings = true;
      const startTime = Date.now();

      try {
        const response = await axios.get(`${config.BASE_URL}/pc/api/parse_video_title.php`, {
          params: {
            user_id: user.id,
            video_url: this.videoUrl,
          },
        });

        if (response.data.code === 200) {
          this.$message.success("视频解析成功");
          this.aiInput = response.data.title; // 将视频标题填充到文本框中
          this.videoParseDialogVisible = false; // 关闭弹窗
          this.videoUrl = ''; // 清空输入
        } else {
          this.$message.error(response.data.msg || "视频解析失败");
        }
      } catch (error) {
        console.error("视频解析失败:", error);
        this.$message.error("视频解析失败，请检查网络");
      } finally {
        // 计算已消耗的时间
        const elapsed = Date.now() - startTime;
        const remainingTime = 3000 - elapsed;
        if (remainingTime > 0) {
          setTimeout(() => {
            this.isLoadings = false;
          }, remainingTime);
        } else {
          this.isLoadings = false;
        }
      }
    },
    async fetchSynthesisRecordz() {
      const user = auth.getStoredUser(); // 从本地存储获取用户信息
      if (!user || !user.id) {
        this.$message.error("用户未登录或用户ID无效");
        return;
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/voice_clone_api.php`, {
          action: "search", // 新增的 action
          user_id: user.id,
          keyword: this.searchValue, // 传递搜索关键字
        });

        if (response.data.success) {
          // 对数据进行排序，确保最新的数据在最前面
          this.synthesisRecords = response.data.data
            .map(record => ({
              ...record,
              isPlaying: false, // 初始化播放状态
            }))
            .sort((a, b) => new Date(b.create_time) - new Date(a.create_time)); // 按创建时间降序排序
        } else {
          this.$message.error("获取合成记录失败");
        }
      } catch (error) {
        console.error("获取合成记录失败:", error);
        this.$message.error("获取合成记录失败，请检查网络");
      }
    },
    // 根据状态获取样式类
    getStatusClass(status) {
      return `status-${status}`;
    },

    // 播放或停止音频
    toggleAudioPlay(record) {
      if (this.audioElement && this.currentRecord === record) {
        // 如果点击的是当前正在播放的记录，则停止播放
        this.audioElement.pause();
        this.audioElement = null;
        this.currentRecord.isPlaying = false;
        this.currentRecord = null;
      } else {
        // 停止之前播放的音频
        if (this.audioElement) {
          this.audioElement.pause();
          this.audioElement = null;
          if (this.currentRecord) {
            this.currentRecord.isPlaying = false;
          }
        }

        // 播放新的音频
        this.audioElement = new Audio(record.voice_clone_url); // 使用 voice_clone_url 播放音频
        this.audioElement.play();
        this.currentRecord = record;
        record.isPlaying = true;

        // 监听音频结束事件
        this.audioElement.addEventListener("ended", () => {
          record.isPlaying = false;
          this.currentRecord = null;
        });
      }
    },

    // 打开命名音频弹窗
    openRenameDialog(record) {
      this.currentRecord = record;
      this.newTitle = record.title;
      this.renameDialogVisible = true;
    },

    // 处理重命名
    async handleRename() {
      if (!this.newTitle.trim()) {
        this.$message.warning("请输入新的音频名称");
        return;
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/voice_clone_api.php`, {
          action: "update",
          id: this.currentRecord.id,
          title: this.newTitle,
        });

        if (response.data.success) {
          this.$message.success("重命名成功");
          this.currentRecord.title = this.newTitle;
          this.renameDialogVisible = false;
        } else {
          this.$message.error("重命名失败");
        }
      } catch (error) {
        console.error("重命名失败:", error);
        this.$message.error("重命名失败，请检查网络");
      }
    },

    // 删除记录
    handleDeleteRecord(record) {
      ElMessageBox.confirm("确定要删除这条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "custom-message-box", // 添加自定义类名

      })
        .then(async () => {
          const user = auth.getStoredUser(); // 从本地存储获取用户信息
          if (!user || !user.id) {
            this.$message.error("用户未登录或用户ID无效");
            return;
          }

          try {
            const response = await axios.post(`${config.BASE_URL}/pc/api/voice_clone_api.php`, {
              action: "delete",
              id: record.id,
              user_id: user.id, // 传递当前用户的 user_id
            });

            if (response.data.success) {
              this.$message.success("删除成功");
              this.synthesisRecords = this.synthesisRecords.filter(
                (item) => item.id !== record.id
              );
            } else {
              this.$message.error("删除失败");
            }
          } catch (error) {
            console.error("删除失败:", error);
            this.$message.error("删除失败，请检查网络");
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 其他方法保持不变
    async fetchOpenAIConfig() {
      try {
        const response = await axios.get(`${config.BASE_URL}/pc/api/get_config_openai.php`);
        if (response.data.success) {
          this.openaiConfig = response.data.data;
        } else {
          ElMessage.error("获取 OpenAI 配置失败");
        }
      } catch (error) {
        console.error("获取 OpenAI 配置失败:", error);
        ElMessage.error("获取 OpenAI 配置失败，请检查网络");
      }
    },

    async fetchVoiceData() {
      const user = auth.getStoredUser(); // 从本地存储获取用户信息
      if (!user || !user.id) {
        this.$message.error("用户未登录或用户ID无效");
        return;
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/voice_sc_api.php`, {
          action: "get",
          user_id: user.id, // 使用本地存储的 user_id
        });

        if (response.data.success) {
          const data = response.data.data;

          // 分类数据并初始化 isSelected 属性
          this.voicelibrary = data.filter(item => item.is_open > 0).map(item => ({ ...item, isSelected: false }));
          this.myvoice = data.filter(item => item.is_open === 0).map(item => ({ ...item, isSelected: false }));
        } else {
          this.$message.error("获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        this.$message.error("获取数据失败，请检查网络");
      }
    },
    // 处理选中状态
    setSelectedVoice(type, index) {
      // 重置所有音频的选中状态
      this.voicelibrary.forEach((voice, i) => {
        voice.isSelected = i === index && type === "voicelibrary";
      });
      this.myvoice.forEach((voice, i) => {
        voice.isSelected = i === index && type === "my-voice";
      });
    },

    // 处理播放逻辑
    togglePlay(type, index) {
      const voiceList = type === "voicelibrary" ? this.voicelibrary : this.myvoice;
      const voice = voiceList[index];

      // 停止之前播放的音频
      if (this.audioElement) {
        this.audioElement.pause();
        this.audioElement = null;
        if (this.currentPlayingType === "voicelibrary") {
          this.voicelibrary[this.currentPlayingIndex].isPlaying = false;
        } else {
          this.myvoice[this.currentPlayingIndex].isPlaying = false;
        }
      }

      // 播放新的音频
      if (this.currentPlayingIndex !== index || this.currentPlayingType !== type) {
        this.audioElement = new Audio(voice.voice_url); // 使用 voice_url 播放音频
        this.audioElement.play();
        this.currentPlayingIndex = index;
        this.currentPlayingType = type;
        voice.isPlaying = true;

        // 监听音频结束事件
        this.audioElement.addEventListener("ended", () => {
          voice.isPlaying = false;
          this.currentPlayingIndex = null;
          this.currentPlayingType = null;
        });
      } else {
        this.currentPlayingIndex = null;
        this.currentPlayingType = null;
      }
    },

    // 点击音频卡片时只设置选中状态
    handleVoiceCardClick(type, index) {
      this.setSelectedVoice(type, index);
    },

    async handleAICreate() {

      if (!this.aiInput.trim()) {
        ElMessage.warning("请输入问题");
        return;
      }

      this.isThinking = true; // 开始加载
      this.voiceText = "正在思考中····"; // 显示加载提示

      try {
        const response = await axios.post(
          this.openaiConfig.openai_url, // OpenAI 接口地址
          {
            model: this.openaiConfig.openai_model, // 模型名称
            messages: [
              {
                role: "user",
                content: this.aiInput, // 用户输入的问题
              },
            ],
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.openaiConfig.openai_key}`, // API Key
            },
          }
        );

        if (response.data.choices && response.data.choices.length > 0) {
          // 获取 AI 回复的内容
          const aiResponse = response.data.choices[0].message.content;
          this.voiceText = aiResponse; // 将回复内容显示在文本域中
          this.aiInput = ""; // 清空文本域
        } else {
          ElMessage.error("未获取到 AI 回复");
          this.voiceText = ""; // 清空文本域
        }
      } catch (error) {
        console.error("调用 OpenAI 接口失败:", error);
        ElMessage.error("AI 创作失败，请稍后重试");
        this.voiceText = ""; // 清空文本域
      } finally {
        this.isThinking = false; // 结束加载
      }
    },



    // 合成声音
    async handleSynthesize() {
      const user = auth.getStoredUser(); // 从本地存储获取用户信息
      if (!user || !user.id) {
        this.$message.error("用户未登录或用户ID无效");
        return;
      }

      // 检查必填字段
      if (!this.voiceName.trim() || !this.voiceText.trim()) {
        this.$message.warning("请输入名称和内容");
        return;
      }

      this.isLoadingd = true;
      const startTime = Date.now();
      // 获取选择的声音
      const selectedVoice = this.getSelectedVoice();
      if (!selectedVoice) {
        this.$message.warning("请选择声音");
        return;
      }

      // 根据 is_open 的值决定 yd_status
      let ydStatus;
      if (selectedVoice.is_open === 2) {
        ydStatus = 3; // 如果 is_open 为 2，yd_status 传递 3
      } else {
        ydStatus = 0; // 否则直接传递 0
      }


      // 构建请求数据
      const requestData = {
        action: "add", // 新增操作
        voice_id: selectedVoice.id, // 被选中音频的ID
        user_id: user.id, // 用户ID
        title: this.voiceName, // 名称
        content: this.voiceText, // 内容
        voice_url: selectedVoice.voice_url, // 声音URL
        author: selectedVoice.title, // 配音人员
        is_open: selectedVoice.is_open, // 是否公开
        size_dx: selectedVoice.size_dx, // 大小
        yd_status: ydStatus, // 根据逻辑传递 yd_status
      };

      try {
        // 调用后端接口
        const response = await axios.post(`${config.BASE_URL}/pc/api/voice_clone_api.php`, requestData);

        if (response.data.success) {
          this.$message.success("合成声音成功");
          this.fetchSynthesisRecords(); // 刷新合成记录
        } else {
          // 显示接口返回的错误信息
          const errorMessage = response.data.error || response.data.message || "合成声音失败";
          this.$message.error(errorMessage);
        }
      } catch (error) {
        console.error("合成声音失败:", error);
        this.$message.error("合成声音失败，请检查网络");
      } finally {
        // 计算已消耗的时间
        const elapsed = Date.now() - startTime;
        const remainingTime = 3000 - elapsed;
        if (remainingTime > 0) {
          setTimeout(() => {
            this.isLoadingd = false;
          }, remainingTime);
        } else {
          this.isLoadingd = false;
        }
      }
    },


    // 获取当前选择的声音
    getSelectedVoice() {
      if (this.activeTab === "ai-male") {
        // 选择声音库的声音
        return this.voicelibrary.find(voice => voice.isSelected);
      } else if (this.activeTab === "my-voice") {
        // 选择我的语音的声音
        return this.myvoice.find(voice => voice.isSelected);
      }
      return null;
    },
    // 获取视频清晰度相关数据
    async fetchVideoClarityValues() {
      try {
        const response = await axios.get(`${config.BASE_URL}/pc/api/get_video_clarity_values.php`);
        if (response.data && response.data.num_words) {
          this.maxWords = parseInt(response.data.num_words, 10); // 设置最大字数
        }
      } catch (error) {
        console.error("获取字数限制失败:", error);
        this.$message.error("获取字数限制失败，请检查网络");
      }
    },
  },
};
</script>

<style scoped>
/* 整体布局：左侧固定，右侧自适应 */
.voice-synthesis {
  display: flex;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background-color: #f5f6fa;
}

/* 自定义提示框样式 */
.custom-tooltip {
  max-width: 400px;
  font-size: 14px;
  line-height: 1.5;
  padding: 12px;
  background-color: #333;
  color: #fff;
  border-radius: 6px;
}

.conversion-button {
  border: 1px solid #eee;
  color: #333;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  padding: 6px 8px;
  border-radius: 4px;
  background-color: #f5f7fa;
}

/* ========== 左侧：合成记录 ========== */
.synthesis-record {
  width: 250px;
  min-width: 220px;
  min-height: 850px;
  /* 设置最小高度 */
  max-height: 1080px;
  /* 设置最大高度 */
  border-right: 1px solid #eee;
  padding-right: 20px;
  box-sizing: border-box;
  background-color: #fff;
  overflow-y: auto;
  /* 超出部分滚动 */
}

.record-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
}

.search-area {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.search-input {
  flex: 1;
}

.search-button {
  background-color: #ff5c00;
  color: #fff;
  border: none;
}

/* 无记录提示 */
.no-record {
  margin-top: 50px;
  text-align: center;
}

/* 记录列表容器 */
.record-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* 增加卡片间距 */
}

/* 记录卡片 */
.record-item {
  position: relative;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  /* 增加阴影 */
}

.record-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  /* 悬停时增加阴影 */
  transform: translateY(-2px);
  /* 悬停时轻微上移 */
}

/* 调整删除和下载按钮的位置 */
.delete-button,
.download-button {
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 4px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.delete-button {
  right: 40px;
  /* 原位置向右移动 */
}

.download-button {
  right: 12px;
  /* 新按钮位置 */
}

.delete-button:hover {
  opacity: 0.8;
  /* 悬停时透明度变化 */
}

.delete-button img {
  width: 16px;
  height: 16px;
}

/* 记录信息 */
.record-info {
  margin-right: 40px;
  /* 为删除按钮留出空间 */
}



.record-time {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.record-status {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
  background-color: #f5f5f5;
  /* 默认背景色 */
  color: #666;
  /* 默认文字颜色 */
}

/* 状态样式 */
.record-item.status-进行中 .record-status {
  background-color: #fff3e0;
  /* 浅橙色 */
  color: #ff5c00;
}

.record-item.status-克隆中 .record-status {
  background-color: #e8f4ff;
  /* 浅蓝色 */
  color: #409eff;
}

.record-item.status-已完成 .record-status {
  background-color: #e8f5e9;
  /* 浅绿色 */
  color: #67c23a;
}

.record-item.status-失败 .record-status {
  background-color: #fee;
  /* 浅红色 */
  color: #f56c6c;
}

/* 操作按钮 */
.record-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.action-button {
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 4px;
  color: #ff5c00;
  /* 按钮文字颜色 */
  background-color: transparent;
  border: 1px solid #ff5c00;
  /* 按钮边框颜色 */
  transition: all 0.3s ease;
}

.action-button:hover {
  background-color: #ff5c00;
  /* 悬停时背景色 */
  color: #fff;
  /* 悬停时文字颜色 */
}

.action-button:disabled {
  color: #ccc;
  /* 禁用时文字颜色 */
  border-color: #ccc;
  /* 禁用时边框颜色 */
  cursor: not-allowed;
  background-color: transparent;
}

/* ========== 右侧：主要编辑/操作区域 + 声音库 ========== */
.right-content {
  flex: 1;
  display: flex;
  gap: 20px;
  background-color: #fff;
  /* 白色背景 */
  border-radius: 12px;
  /* 圆角 */
  margin: 20px;
  /* 外边距 */
  padding: 20px;
  /* 内边距 */
  padding-bottom: 40px;
  /* 底部留白，稍微超出内容高度 */
  box-sizing: border-box;
  /* 避免 padding 影响高度 */
  min-height: 300px;
  /* 设置最小高度 */
  max-height: 550px;
  /* 设置最大高度 */
}

/* 主要编辑/操作区域 */
.left-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* 名称行 */
.name-row {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #f5f7fa;
  border-radius: 6px;
  padding: 8px 12px;
}

.name-row .label {
  font-weight: 500;
  color: #666;
  min-width: 50px;
}

/* 输入框 & 文本域 */
.voice-name-input {
  flex: 1;
}

.voice-textarea {
  width: 100%;
  min-height: 396px;
  /* 设置最小高度 */
  max-height: 400px;
  /* 设置最大高度 */
  color: #a62020;
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow-y: auto;
  /* 超出部分滚动 */
}

/* AI操作按钮区 */
.ai-operation-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.ai-create-button {
  background-color: #ff5c00;
  color: #fff;
  border: none;
}

/* 下拉和输入 */
.dropdown-controls {
  display: flex;
  gap: 10px;
}

.dropdown-trigger {
  cursor: pointer;
  color: #333;
  display: inline-flex;
  align-items: center;
  padding: 6px 8px;
  border-radius: 4px;
  background-color: #f5f7fa;
}

.ai-input {
  flex: 1;
  min-width: 160px;
}

/* 声音库/我的语音 */
.right-panel {
  width: 400px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Tab 区 */
.voice-tabs {}

/* 音色列表 */
.voice-options {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  height: 385px;
  /* 固定高度 */
  overflow-y: auto;
  /* 超出部分滚动 */
  padding-right: 8px;
  /* 避免滚动条遮挡内容 */
}

/* 音色卡片 */
.voice-card {
  width: 170px;
  height: 100px;
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  transition: all 0.2s ease;
  cursor: pointer;
  background: #fff;
  box-sizing: border-box;
}

.voice-card:hover {
  background-color: #f9f9f9;
}

/* 选中状态 */
.voice-card.is-selected {
  border: 2px solid #ff5c00;
  /* 选中时边框颜色 */
  background-color: #fff3e0;
  /* 选中时背景颜色 */
}

.play-icon {
  width: 36px;
  height: 36px;
  margin-right: 12px;
}

.voice-info {
  flex: 1;
}

.voice-title {
  margin: 0;
  font-weight: bold;
}

.voice-tag {
  margin: 2px 0 0;
  font-size: 12px;
  color: #888;
}

/* 底部：滑块与按钮 */
.sliders-and-button {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.synthesize-button {
  align-self: flex-start;
  background-color: #ff5c00;
  color: #fff;
  width: 100%;
  border: none;
}

/* 加载状态样式 */
.ai-operation-row .el-button.is-disabled {
  background-color: #ccc !important;
  border-color: #ccc !important;
  cursor: not-allowed;
}

.ai-operation-row .el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  cursor: not-allowed;
}

.textarea-container {
  position: relative;
}

.word-count {
  position: absolute;
  right: 10px;
  bottom: 10px;
  font-size: 12px;
  color: #666;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 2px 6px;
  border-radius: 4px;
}

.video-parse-dialog .el-dialog__body {
  padding: 20px;
}

.video-parse-dialog .el-input {
  width: 100%;
}
</style>